import React from "react";
import logoImage from "../../images/NWP-logo.webp";
import ContentContainer from "../container/ContentContainer";
import { NavBar, NavItem, NavLogo } from "../controls/Navigation";
require("../controls/Navigation");

const Header = ({isHome}) => {
  
  return (
    <ContentContainer containerClassName="w-screen min-w-full h-32 z-30" className="h-32">
      <NavBar
        actionClassName="text-gray1 h-1/2 xl:h-full px-4 py-6 rounded-sm text-xs lg:text-base
            lg:bg-opacity-60 lg:hover:bg-opacity-100 font-semibold flex justify-center items-center"
        logoClassName="flex w-28 h-28 justify-center items-center relative top-2"
        className="w-full h-16 flex flex-row px-2 lg:px-0 z-30"
        supportMobile={true}
        isHome={isHome}
      >
        <NavLogo name="NavLogo" link="/" image={logoImage} width="100px" className />
        <NavItem
          name="NavItem"
          link="/about"
          className={`px-4 font-sans ${isHome? "text-white" : "text-gray1"} text-base font-semibold flex items-end`}
        >
          About
        </NavItem>
        <NavItem
          name="NavItem"
          link="/products"
          className={`px-4 font-sans ${isHome? "text-white" : "text-gray1"} text-base font-semibold flex items-end`}
        >
          Products
        </NavItem>
        <NavItem
          name="NavItem"
          link="/blog"
          className={`px-4 font-sans ${isHome? "text-white" : "text-gray1"} text-base font-semibold flex items-end`}
        >
          Blog
        </NavItem>
        <NavItem
          name="NavItem"
          link="/forms"
          className={`px-4 font-sans ${isHome? "text-white" : "text-gray1"} text-base font-semibold flex items-end`}
        >
          Forms
        </NavItem>
        <NavItem
          name="NavItem"
          link="/jobs"
          className={`px-4 font-sans ${isHome? "text-white" : "text-gray1"} text-base font-semibold flex items-end`}
        >
          Jobs
        </NavItem>
        <NavItem
          name="NavItem"
          link="/contact"
          className={`px-4 font-sans ${isHome? "text-white" : "text-gray1"} text-base font-semibold flex items-end`}
        >
          Contact
        </NavItem>
      </NavBar>
    </ContentContainer>
  );
};

export default Header;
